import React, { Component } from 'react'
import { connect } from 'redaction'
import actions from 'redux/actions'

import Icon from 'components/_new/ui/Icon/Icon'

import Sections from './Sections/Sections'

import s from './FiltersOverlay.scss'


class FiltersOverlay extends Component {

  close = () => {
    actions.view.smartSearchPage.closeFiltersOverlay()
  }

  clearFilters = () => {
    actions.view.smartSearchPage.clearFilters()
    actions.view.smartSearchPage.fetchFragrances()
    this.close()
  }

  render() {
    const { isVisible } = this.props

    return isVisible && (
      <div className={s.filtersOverlay}>
        <div className={s.header}>
          <button className={s.closeButton} onClick={this.close} type="button">
            <Icon name="closeLight" />
          </button>
        </div>
        <div className={s.content}>
          <Sections />
        </div>
      </div>
    )
  }
}


export default connect({
  isVisible: 'view.smartSearchPage.isFiltersOverlayVisible',
})(FiltersOverlay)
